import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';

export const TIME_SETTING_SCHEMA = Yup.array().of(
    Yup.object().shape({
        day: Yup.number().required('Day is required'),
        isClosed: Yup.boolean(),
        startTime: Yup.string().when('isClosed', ([isClosed], schema) => {
            if (isClosed === false) {
                return schema
                    .required(CommonMessages.start_time_required)
                    .test(
                        'isValidTime',
                        CommonMessages.start_time_invalid,
                        function (startTime) {
                            const { endTime } = this.parent;
                            // Skip test if startTime is not provided.
                            if (!startTime) return true;
                            if (!endTime) return true;
                            return toMinutes(startTime) < toMinutes(endTime);
                        }
                    );
            }
            return schema.notRequired(); // Not required if isClosed is true
        }),
        endTime: Yup.string().when('isClosed', ([isClosed], schema) => {
            if (isClosed === false) {
                return schema
                    .required(CommonMessages.end_time_required)
                    .test(
                        'isValidTime',
                        CommonMessages.end_time_invalid,
                        function (endTime) {
                            const { startTime } = this.parent;
                            console.log(startTime)
                            // Skip test if startTime is not provided.
                            if (!startTime) return true;
                            if (!endTime) return true;
                            return toMinutes(startTime) < toMinutes(endTime); // Validate start < end
                        }
                    );
            }
            return schema.notRequired(); // Not required if isClosed is true
        }),

    })
);

const toMinutes = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};
